import { Component, OnInit } from '@angular/core';

// Services
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-cost-pool-new-admin-page',
    templateUrl: './cost-pool-new.component.html',
    styleUrls: ['./cost-pool-new.component.scss']
})

export class CostPoolNewAdminComponent implements OnInit {
    public employeeId: number;

    constructor(private authService: AuthService) { }

    ngOnInit(): void {
        this.employeeId = this.authService.getEmployeeId();
    }
}
